import { useEffect, useState, useCallback } from "react";
import { signalRService } from "./signalRServices.js";
import { notificationService } from "../services/notificationService.js";
 

export function useNotificationSignalR(options = {}) {
  const { onShowToast } = options;
 
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
 
  const fetchNotifications = useCallback(async () => {
    try {
      const res = await notificationService.getUnreadNotifications();
      const data = res?.data || [];
      setNotifications(data);
      setUnreadCount(data.length);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }, []);
 
  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);
 
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;
 
    // start singleton connection
    signalRService.start(token);
 
    // listen to events
    const handler = (data) => {
      console.log("📬 SeedStatus:", data);
 
      const message = data.message || `${data.type} ${data.status}`;
 
      const type =
        data.status === "Succeeded" || data.status === "Completed" || data.status === "Running" || data.status === "Success"
          ? "success"
          : data.status === "Failed"
          ? "error"
          : "info";
 
      onShowToast?.({
        message,
        type,
        suppressGeneric: !!data.nofUnread,
      });
 
      if (data.nofUnread !== undefined) {
        setUnreadCount(data.nofUnread);
      }
    };
 
    signalRService.on("SeedStatus", handler);
 
    return () => {
      signalRService.off("SeedStatus", handler);
    };
  }, [onShowToast]);
 
  return {
    notifications,
    unreadCount,
    refetch: fetchNotifications,
  };
}